import React from 'react';
import { OnboardingContext } from './OnboardingContext';

const withOnboarding = Component => {
  return function withOnboardingComponent(props) {
    return (
      <OnboardingContext.Consumer>
        {contextProps => <Component {...props} {...contextProps} />}
      </OnboardingContext.Consumer>
    );
  };
};

export default withOnboarding;



// WEBPACK FOOTER //
// ./src/components/onboarding/withOnboarding.js